import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import {
  mockMonetaryVerifications,
  mockMonetaryVerificationDetails,
  mockProfileDataCheck,
  mockUboCheck,
  mockPaymentDetailsCheck,
  mockAdyenSpecificCheck
} from '@percent/admin-dashboard/fixtures/api/monetaryVerifications/mockGetMonetaryVerificationsResponse'

export const monetaryVerificationsHandlers = [
  rest.get(`${config.urls.api}v1/admin/monetary-donation-verifications`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockMonetaryVerifications))
  }),
  rest.get(`${config.urls.api}v1/admin/monetary-donation-verifications/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockMonetaryVerificationDetails))
  }),
  rest.get(`${config.urls.api}v1/admin/experience/profile-data-checks/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockProfileDataCheck))
  }),
  rest.get(`${config.urls.api}v1/admin/aml-compliance/ubo-checks/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockUboCheck))
  }),
  rest.post(
    `${config.urls.api}v1/admin/experience/profile-data-checks/:verificationId/resolve`,
    async (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          data: {
            profileDataCheckId: 'profile-data-check-uuid-12345',
            status: 'succeeded'
          }
        })
      )
    }
  ),
  rest.post(`${config.urls.api}v1/admin/aml-compliance/ubo-checks/:verificationId/resolve`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ data: { uboCheckId: 'ubo-check-uuid-12345', status: 'succeeded' } }))
  }),
  rest.get(`${config.urls.api}v1/admin/disbursements/payment-details-checks/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockPaymentDetailsCheck))
  }),
  rest.post(
    `${config.urls.api}v1/admin/disbursements/payment-details-checks/:verificationId/resolve`,
    async (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          data: {
            paymentDetailsCheckId: 'payment-details-check-uuid-12345',
            status: 'succeeded'
          }
        })
      )
    }
  ),
  rest.get(`${config.urls.api}v1/admin/partner-specific-checks/adyen-specific-checks/:id`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockAdyenSpecificCheck))
  }),
  rest.post(
    `${config.urls.api}v1/admin/partner-specific-checks/adyen-specific-checks/:verificationId/resolve`,
    async (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          data: {
            adyenSpecificCheckId: 'adyen-specific-check-uuid-12345',
            status: 'succeeded'
          }
        })
      )
    }
  )
]
